import * as SelectPrimitive from "@radix-ui/react-select";
import { ComponentProps } from "react";
import { NullUUID } from "@/shared/lib/utilities/uuid";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import t from "@/lang/lang";
import { RefreshCw } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useCustomersServiceObjectListQuery } from "@/services/backend/customers/api/service-object-api";

export function ServiceObjectSelectFrom({
  serviceObjectIds,
  customerId,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  serviceObjectIds: string[];
  customerId?: string;
}) {
  const { data, isLoading, error } = useCustomersServiceObjectListQuery({
    customer: {
      active: customerId !== undefined,
      values: [customerId ?? NullUUID],
    },
  });
  const serviceObjects =
    data?.serviceObjects.filter((s) => serviceObjectIds.includes(s.id)) ?? [];

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Service Objekt auswählen")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {isLoading && (
            <SelectItem value="loading" disabled>
              <RefreshCw className="size-4" />
              <span>{t("Lade Objekte")}</span>
            </SelectItem>
          )}
          {error && (
            <SelectItem value="error" disabled>
              <RTKQueryErrorAlert error={error} />
            </SelectItem>
          )}
          {serviceObjects.map((serviceObject) => (
            <SelectItem value={serviceObject.id} key={serviceObject.id}>
              <span>{serviceObject.name}</span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
